import { apiClient, fastApiClient } from "../App";

// Insider Risk Dashboard
export const getInsiderRisk = (status, limit) => {
  const params = {};
  if (status) params.status = status;
  if (limit) params.limit = limit;
  return fastApiClient.get("/dashboard/insider-risk", { params });
};